export enum NextOrPrevEnum {
  Next = 1,
  Prev = -1
}

export enum SelectionTypeEnum {
  Monthly = 'month',
  Yearly = 'year',
  Quarterly = 'quarterly'
}
export enum SelectionTypeIndexEnum {
  'year',
  'quarterly',
  'month'
}

export enum ActiveComponentEnum {
  List,
  EntityDetails,
  Map,
  Chart
}

export enum SessionPeriodsEnum {
  selectedYear = 'selectedYear',
  selectedMonths = 'selectedMonths'
}

export enum MonthEnum {
  January = 1,
  February,
  March,
  April,
  May,
  June,
  July,
  August,
  September,
  October,
  November,
  December
}

export enum GenderEnum {
  Male = "100000000",
  Female = "100000001"
}

export enum HowComplaintsAreReceivedEnum {
  Internet = "1",
  Email = "2",
  Reception = "3",
  Fax = "4",
  Phone = "5",
  Mail = "6",
}

export enum DistrictEnum {
  North = "1",
  Haifa = "2",
  TelAviv = "3",
  JudeaAndSamaria = "4",
  Jerusalem = "5",
  Center = "6",
  South = "7",
}

export enum QuartersEnum {
  Quarterly1,
  Quarterly2,
  Quarterly3,
  Quarterly4,
}

export enum PeriodApiParamsEnum {
  Year = 'Year',
  Months = 'Months'
};
export enum FirstCategoryEnum {
  GovernmentOffices = "100000000",
  StateInstitutions = "100000001",
  LocalGovernmentBodies = "100000002",
  OtherPublicBodies = "100000003"
}

export enum HandlingComplaintsEnum {
  Justified = "1",
  NotJustified = "2",
  CompletionOfProcesses = "3",
  NoDecision = "4"
}
export enum DefaultLogoEnum {
  GovernmentOffices = "100000000",
  StateInstitutions = "100000001",
  LocalGovernmentBodies = "100000002",
  OtherPublicBodies = "100000003"
}

export enum TooltipPlacementEnum {
  Top = 'top', 
  Right = 'right', 
  Bottom = 'bottom', 
  Left = 'left',
}

export enum TooltipTriggerEnum {
  Hover = 'hover', 
  Click = 'click', 
  Focus = 'focus', 
}

export enum PopulationGraphTypeEnum {
  Age = 0,
  Education = 1,
  Religion = 2,
}

export enum MediaQuery {
  Mobile = 'Mobile',
  Tablet = 'Tablet',
  NotDesktop = 'NotDesktop',
  Desktop = 'Desktop',
};